import at from '../../actionTypes'
import generateActionCreators from './utilities/generateActionCreators'

const authActions = {
	...generateActionCreators(at.auth, 'auth'),
	...generateActionCreators(at.authFacebookPopup, 'authFacebookPopup'),
	...generateActionCreators(at.authFacebookRedirect, 'authFacebookRedirect'),
	...generateActionCreators(at.authInstagramPopup, 'authInstagramPopup'),
	...generateActionCreators(at.authInstagramRedirect, 'authInstagramRedirect'),
	...generateActionCreators(at.authEmail, 'authEmail')
}

export default authActions



// WEBPACK FOOTER //
// ./src/redux/actionCreators/old_actions/authActions.js